import { set } from 'lodash';

import type * as Microcredits from '@src/@types/microcredits';

export const formatOffersAbSea = (items: Microcredits.List.IMicrocredit[]) =>
  items.filter((item) => !item?._features?.isSravniOffer).map((item) => set(item, '_features.isFullDealOffer', false));
